import { render, staticRenderFns } from "./SolutionTypeAdd.vue?vue&type=template&id=e1b01546&scoped=true&"
import script from "./SolutionTypeAdd.vue?vue&type=script&lang=js&"
export * from "./SolutionTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b01546",
  null
  
)

export default component.exports